import React, { useMemo } from 'react'
import { ReplaySessionProvider } from './context/ReplaySessionContext'
import { ReplayPlaybackControllerProvider } from './context/ReplayPlaybackControllerContext'
import { ReplayTelemetryFiltererProvider } from './context/ReplayTelemetryFiltererContext'
import { ReplayCodeProvider } from './context/ReplayCodeContext'
import { ReplayTerminalProvider } from './context/ReplayTerminalContext'
import { ReplayChatProvider } from './context/ReplayChatContext'
import { ReplayMouseProvider } from './context/ReplayMouseContext'
import { ReplayOrchestrator } from './context/ReplayOrchestratorContext'
import Navbar from '../workspace/components/Navbar' 
import ReplayWorkspace from '../workspaceReplay/ReplayWorkspace'
import '../../css/codeIssuePanel.scss'

const ReplayWorkspacePage = React.memo(({ 
  sessionId, 
  task, 
  testCases, 
  testList, 
  starterCode, 
  events = [], 
  onTimeUpdate,
  taggedBlocks = [],
  activeRecording = null,
  // Selection props
  selectionMode = false,
  timelineSelection = null,
  onSelectionChange = null
}) => {
    console.log('ReplayWorkspacePage received:', {
    eventsLength: events.length,
    firstEvent: events[0],
    isArray: Array.isArray(events)
  })

  // DATA PREP: Handle both DB Chunks (Strings) and Live Arrays (Objects)
  const processedEvents = useMemo(() => {
    if (!events || events.length === 0) return []

    let flatList = []

    try {
      // CHECK 1: Is this a Live Session? (Array of raw event objects)
      const firstItem = events[0]
      if (firstItem && (firstItem.type || firstItem.event_type) && !firstItem.events) {
        flatList = events
      } 
      // CHECK 2: Is this a DB Archive? (Array of rows with .events string/array)
      else {
        events.forEach(row => {
          if (typeof row.events === 'string') {
            const chunk = JSON.parse(row.events)
            flatList = flatList.concat(chunk)
          } else if (Array.isArray(row.events)) {
            flatList = flatList.concat(row.events)
          }
        })
      }
    } catch (err) {
      console.error("Failed to parse event chunks", err)
    }

    console.log('processedEvents DEBUG:', {
      flatListLength: flatList.length,
      firstTimestamp: flatList[0]?.timestamp,
      lastTimestamp: flatList[flatList.length - 1]?.timestamp
    })

    // 2. NORMALIZE & SORT
    return flatList
      .map(e => ({
        ...e,
        event_time: e.event_time || new Date(e.timestamp).toISOString(), 
        event_type: e.event_type || e.type, 
        timestamp: Number(e.timestamp)
      }))
      .sort((a, b) => a.timestamp - b.timestamp)
  }, [events])

  return (
    <div className="home" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Navbar />
      <ReplaySessionProvider 
        sessionId={sessionId} 
        task={task} 
        testCases={testCases}
        testList={testList}   
        starterCode={starterCode}
        events={processedEvents}
      >
        <ReplayPlaybackControllerProvider 
          onTimeUpdate={onTimeUpdate}
          taggedBlocks={taggedBlocks}
          activeRecording={activeRecording}
          selectionMode={selectionMode}
          timelineSelection={timelineSelection}
          onSelectionChange={onSelectionChange}
        >
          <ReplayTelemetryFiltererProvider events={processedEvents}>
            <ReplayCodeProvider>
              <ReplayTerminalProvider>
                <ReplayChatProvider>
                  <ReplayMouseProvider>
                    <ReplayOrchestrator />
                    <div className="container" style={{ flex: 1, overflow: 'hidden' }}>
                      <ReplayWorkspace />
                    </div>
                  </ReplayMouseProvider>
                </ReplayChatProvider>
              </ReplayTerminalProvider>
            </ReplayCodeProvider>
          </ReplayTelemetryFiltererProvider>
        </ReplayPlaybackControllerProvider>
      </ReplaySessionProvider>
    </div>
  )
})

export default ReplayWorkspacePage